module.exports = __webpack_public_path__ + "static/img/Peter-Sterling.702bc91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Peter-Sterling.jpg
// module id = RxhC
// module chunks = 0